const recomendedMovies = [
	{
		title: "Spider-Man: Across the Spider-Verse",
		description:
			"After reuniting with Gwen Stacy, Brooklyn\u2019s full-time, friendly neighborhood Spider-Man is catapulted across the Multiverse, where he encounters the Spider Society, a team of Spider-People charged with protecting the Multiverse\u2019s very existence. But when the heroes clash on how to handle a new threat, Miles finds himself pitted against the other Spiders and must set out on his own to save those he loves most.",
		tagline: "It's how you wear the mask that matters.",
		year: "2023",
		release_date: "2023-05-31",
		imdb_id: "tt9362722",
		imdb_rating: "8.4",
		vote_count: "6232",
		popularity: "237.904",
		youtube_trailer_key: "shW9i6k8cB0",
		rated: "PG",
		runtime: 140,
		genres: ["Animation", "Action", "Adventure", "Sci-Fi", "Superhero", "Romance", "Family", "Fantasy", "Comedy"],
		stars: [
			"Shameik Moore",
			"Hailee Steinfeld",
			"Jason Schwartzman",
			"Oscar Isaac",
			"Brian Tyree Henry",
			"Luna Lauren Velez",
			"Jake Johnson",
			"Issa Rae",
			"Karan Soni",
			"Shea Whigham",
			"Greta Lee",
			"Amandla Stenberg",
			"Jharrel Jerome",
			"Andy Samberg",
			"Jack Quaid",
			"Rachel Dratch",
			"Ziggy Marley",
			"Jorma Taccone",
			"Daniel Kaluuya",
			"Mahershala Ali",
			"J.K. Simmons",
			"Donald Glover",
			"Elizabeth Perkins",
			"Kathryn Hahn",
			"Ayo Edebiri",
			"Nicole Delaney",
			"Antonina Lentini",
			"Atsuko Okatsuka",
			"Peter Sohn",
			"Melissa Sturm",
			"Lorraine Velez",
			"Nic Novicki",
			"Taran Killam",
			"Metro Boomin",
			"Josh Keaton",
			"Sofia Barclay",
			"Danielle Perez",
			"Yuri Lowenthal",
			"Rita Rani Ahuja",
			"Ismail Bashey",
			"Oscar Camacho",
			"Freddy Ferrari",
			"Kerry Gutierrez",
			"Kamal Khan",
			"Angelo Sekou Kouyate",
			"Andrew Leviton",
			"David Michie",
			"Sumit Naig",
			"Juan Pacheco",
			"Chrystee Pharris",
			"Ben Pronsky",
			"Al Rodrigo",
			"Stan Sellers",
			"Warren Sroka",
			"Jasper Johannes Andrews",
			"Gredel Berrios Calladine",
			"Natalia Castellanos",
			"Russell Tyre Francis",
			"Deepti Gupta",
			"Sohm Kapila",
			"Pradnya Kuwadekar",
			"Ashley London",
			"Christopher Miller",
			"Andrea Navedo",
			"Lakshmi Patel",
			"Jacqueline Pinol",
			"Eliyas Qureshi",
			"Lashana Rodriguez",
			"Jaswant Dev Shrestha",
			"Libby Thomas Dickey",
			"Jason Linere-White",
			"Sitara Attaie",
			"Mayuri Bhandari",
			"June Christopher",
			"Michelle Jubilee Gonzalez",
			"Marabina Jaimes",
			"Rez Kempton",
			"Lex Lang",
			"Phil Lord",
			"Richard Miro",
			"Doug Nicholas",
			"Shakira Ja'nai Paye",
			"James Pirri",
			"Marley Ralph",
			"Michelle Ruff",
			"Dennis Singletary",
			"Amanda Troop",
			"Ruth Zalduondo",
			"Kimberly Bailey",
			"Sanjay Chandani",
			"Melanie Duke",
			"Jorge R. Gutierrez",
			"Miguel Jiron",
			"Deepti Kingra-Mickelsen",
			"Luisa Leschin",
			"Caitlin McKenna",
			"Andrew Morgado",
			"Arthur Ortiz",
			"Eliana A. Perez",
			"Juan Pope",
			"Mike Rianda",
			"Erika Scopelli",
			"Narender Sood",
			"Cedric L. Williams",
			"Kimiko Glenn",
			"Peggy Lu",
			"Andrew Garfield",
			"Denis Leary",
			"Tobey Maguire",
			"Cliff Robertson",
			"Alfred Molina",
			"Post Malone",
		],
		directors: ["Justin K. Thompson", "Joaquim Dos Santos", "Kemp Powers", "Melanie Duke"],
		countries: ["United States of America"],
		language: ["English", "\u0939\u093f\u0928\u094d\u0926\u0940", "Italiano", "Espa\u00f1ol", "en"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Witcher: Nightmare of the Wolf",
		description:
			"Escaping from poverty to become a witcher, Vesemir slays monsters for coin and glory, but when a new menace rises, he must face the demons of his past.",
		tagline: "Face your demons.",
		year: "2021",
		release_date: "2021-08-23",
		imdb_id: "tt11657662",
		imdb_rating: "7.519",
		vote_count: "902",
		popularity: "23.017",
		youtube_trailer_key: "v1Zi8rIipYM",
		rated: "R",
		runtime: 83,
		genres: ["Animation", "Action", "Fantasy", "Adventure", "Drama", "Mystery"],
		stars: [
			"Theo James",
			"Mary McDonnell",
			"Lara Pulver",
			"Graham McTavish",
			"Tom Canton",
			"David Errigo Jr.",
			"Jennifer Hale",
			"Kari Wahlgren",
			"Matthew Yang King",
			"Darryl Kurylo",
			"Keith Ferguson",
			"Jennie Kwan",
			"A.J. LoCascio",
			"Michaela Dietz",
			"Harry Hissrich",
			"Adam Croasdell",
			"Nolan North",
			"Samia Mounts",
			"Luke Youngblood",
			"Ry Chase",
			"Steve Blum",
			"Dee Bradley Baker",
			"Sara Cravens",
			"JP Karliak",
			"Andrew Morgado",
			"Fred Tatasciore",
			"Courtenay Taylor",
			"Abby Trott",
		],
		directors: ["Kilo", "LAN", "Daniel Baron", "Yen BM", "nasiijau", "Han Kwang-il", "Nasiijau"],
		countries: ["Poland", "South Korea", "United States of America"],
		language: ["English", "en"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Secret Life of Walter Mitty",
		description:
			"A timid magazine photo manager who lives life vicariously through daydreams embarks on a true-life adventure when a negative goes missing.",
		tagline: "Stop dreaming. Start living.",
		year: "2013",
		release_date: "2013-12-18",
		imdb_id: "tt0359950",
		imdb_rating: "7.182",
		vote_count: "7295",
		popularity: "44.801",
		youtube_trailer_key: "Bp_cxxqOaPM",
		rated: "PG",
		runtime: 114,
		genres: ["Adventure", "Comedy", "Drama", "Fantasy", "Action", "Romance"],
		stars: [
			"Ben Stiller",
			"Kristen Wiig",
			"Sean Penn",
			"Shirley MacLaine",
			"Adam Scott",
			"Kathryn Hahn",
			"Patton Oswalt",
			"Adrian Martinez",
			"\u00d3lafur Darri \u00d3lafsson",
			"Gunnar Helgason",
			"Terence Bernie Hines",
			"Alex Anfanger",
			"Gary Wilmes",
			"Jon Daly",
			"Gurdeep Singh",
			"Paul Fitzgerald",
			"Grace Rex",
			"Amanda Naughton",
			"Nolan Carley",
			"Joey Slotnick",
			"Marcus Antturi",
			"Amy Stiller",
			"Rosamund Gundmundsdottir",
			"Stuart Cornfeld",
			"Maariu Olsen",
			"Makka Kleist",
			"\u00de\u00f3rhallur Sigur\u00f0sson",
			"Ari Matth\u00edasson",
			"Hendrikus Schraven",
			"Finni Johannsson",
			"Eysteinn Gardarsson",
			"Jos\u00e9 Alc\u00e1ntara",
			"Rodrigo Espinosa",
			"Seba Al\u00f3n",
			"Miguel Baez-Olavarria",
			"Daniel Orellana",
			"Antonio Molina",
			"Martin Lagos",
			"Andres Quezada",
			"Valur Snaer Hilmarsson",
			"Eythor Atli Hilmarsson",
			"Birgir Jarl Runarsson",
			"Kai Lennox",
			"Conan O'Brien",
			"Andy Richter",
			"Anthony Desio",
			"Losang Thonden",
			"Rinjee Sherpa",
			"Haroon Nawabi",
			"Stefan B. Onundarson",
			"Mohammed Arif Baser",
			"Mohammed Pancherri",
			"Ehsan Nawroz",
			"Steve Assil",
			"Ang Babu Sherpa",
			"Ang Gelu Sherpa",
			"Dawa Sherpa",
			"Ngima T. Sherpa",
			"Nuri Chhiri Sherpa",
			"Lhakpa Sonam Sherpa",
			"Phurba Tashi Sherpa",
			"Walter Mudu",
			"Liz Mikel",
			"Brian Scott McFadden",
			"Dion Graham",
			"Richard DeDomenico",
			"Matt Levin",
			"Craig 'Radioman' Castaldo",
			"George Aloi",
			"Paul Bosche",
			"Jerome Brooks Jr.",
			"Brady Bryson",
			"Greg Cipes",
			"Marmee Regine Cosico",
			"Jay Ferraro",
			"Gary Ferster",
			"Samantha Gelnaw",
			"Efraiem Hanna",
			"Rosemary Howard",
			"Ilan Krigsfeld",
			"Alex Kruz",
			"Anna Kuchma",
			"Dennis Lauricella",
			"Raymond Mamrak",
			"Jennifer Leigh Mann",
			"Ryan McBride",
			"Ryan Nicolls",
			"Hal Panchansky",
			"Roy Pollack",
			"Wes Pope",
			"Lil Rhee",
			"Bennie Road",
			"Shade Rupe",
			"Stephen Sapienza",
			"Chloe Elaine Scharf",
			"Joshua Schubart",
			"Tara Strong",
			"Rob Tode",
			"Marco Torriani",
			"Barbara Vincent",
			"Hynden Walch",
			"Kelsey Wang",
			"Christopher Watts",
			"William Henderson White",
			"Nicole Neuman",
			"Dennis Rees",
			"Asta Paredes",
			"Sonam Sherpa",
			"Roger Brenner",
			"Brian Gildea",
			"Matthew Gooley",
			"Saima Huq",
			"Kenneth Kopolovicz",
			"Lucinda Lewis",
			"Toshiko Onizawa",
			"Peter Riga",
			"Kathryn Shasha",
			"Lynne Valley",
			"Joe Vargas",
			"Jos\u00e9 Antonio Alc\u00e1ntara",
			"Craig Castaldo",
			"Caleigh Anne",
			"Katelynn Bailey",
			"Greg Burmeister",
			"Amirak Nallem Capozzollo",
			"Robert Chang",
			"Emily Chapman",
			"Richard R. Corapi",
			"Craig Dourmashkin",
			"Sarah Dulat",
			"Don Ellione",
			"Lalaine Fabi",
			"Leeann Hellijas",
			"Zivile Kaminskaite",
			"Alex Korik",
			"Lexie LaPlante",
			"Adam Leong",
			"Guillermo Lozano",
			"Patrick Michael Malloy",
			"Chris McFarland",
			"Brian Murray",
			"Philip Odango",
			"Rebecca Pensky",
			"Lou Ravelli",
			"Jenny Rostain",
			"Greg Sammis",
			"Joe Sergio",
			"Eli Shannon",
			"George Signoriello",
			"Isabelle Sitterle",
			"Aynsley Thaler",
			"Michael Valentino",
			"Jenalyn Villegas",
			"Pat Zinnanti",
		],
		directors: ["Ben Stiller", "Thomas Johnston", "Phil Neilson", "David H. Venghaus Jr.", "Peter Thorell"],
		countries: ["United Kingdom", "United States of America", "USA, UK"],
		language: ["English", "\u00cdslenska", "Espa\u00f1ol", "en", "English, Spanish, Icelandic"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Kingsman: The Secret Service",
		description:
			"The story of a super-secret spy organization that recruits an unrefined but promising street kid into the agency's ultra-competitive training program just as a global threat emerges from a twisted tech genius.",
		tagline: "Manners maketh man.",
		year: "2014",
		release_date: "2014-12-13",
		imdb_id: "tt2802144",
		imdb_rating: "7.6",
		vote_count: "12482",
		popularity: "75.291",
		youtube_trailer_key: "Th_KrhqmHk8",
		rated: "R",
		runtime: 129,
		genres: ["Crime", "Comedy", "Action", "Adventure", "Thriller"],
		stars: [
			"Taron Egerton",
			"Colin Firth",
			"Mark Strong",
			"Samuel L. Jackson",
			"Sophie Cookson",
			"Sofia Boutella",
			"Michael Caine",
			"Adrian Quinton",
			"Jonno Davies",
			"Jack Davenport",
			"Alex Nikolov",
			"Samantha Womack",
			"Mark Hamill",
			"Velibor Topic",
			"Geoff Bell",
			"Jordan Long",
			"Theo Barklem-Biggs",
			"Tobi Bakare",
			"Morgan Watkins",
			"Paul Kennington",
			"Ralph Ineson",
			"Edward Holcroft",
			"Nicholas Banks",
			"Jack Cutmore-Scott",
			"Nicholas Agnew",
			"Rowan Polonski",
			"Tom Prior",
			"Fiona Hampton",
			"Bj\u00f8rn Floberg",
			"Hanna Alstr\u00f6m",
			"Johanna Taylor",
			"Lily Travers",
			"Richard Brake",
			"Andrew Bridgmont",
			"Corey Johnson",
			"Anne Wittman",
			"Andrei Lenart",
			"Simon Green",
			"Lazara Storm",
			"Sarah Hewson",
			"Jayne Secker",
			"Lukwesa Burak",
			"James Clayton",
			"Nick English",
			"Charles Filmer",
			"Bimbo Hart",
			"Chester King",
			"Alastair MacIntosh",
			"Carlos Peres",
			"Lee Nicholas Harris",
			"Jamie B. Chambers",
			"Talin Agon",
			"Adil Akram",
			"Mohammed Ali",
			"Danielle Kirsty Allan",
			"David Olawale Ayinde",
			"Mark Baxter",
			"Roy Beck",
			"Tom Bell",
			"Francesca Bennett",
			"Paul Biddiss",
			"Paulina Boneva",
			"Alexander Bracq",
			"Jay E Brown",
			"Jaymes Butler",
			"Dean Chapman",
			"Daniel Chapple",
			"Alan Chimes",
			"Victoria Coker",
			"Bern Colla\u00e7o",
			"Christoph Cordell",
			"Justin Cosh",
			"Graham Curry",
			"Maryam Soumare Dahan",
			"Leigh Dent",
			"Ben Dilloway",
			"Erica Emm",
			"David Few-Cooper",
			"Yolandi Franken",
			"Demeko Frazer",
			"Kevin Fyfe",
			"Neve Gachev",
			"Alex Gillison",
			"Dave Goshorn",
			"Claire Greasley",
			"James Harris",
			"Matt Harris",
			"Stefanie Harris",
			"Jay Heath",
			"John Hiorns",
			"Leigh Holland",
			"Matt Hookings",
			"Laura Hydari",
			"Tobias James-Samuels",
			"Rajesh Kalhan",
			"Rodion Kilinc",
			"Jefferson King",
			"Anna Krippa",
			"Jorge Leon Martinez",
			"Marian Lorencik",
			"Gertie Lowe",
			"Shawn Majeski",
			"Stuart Matthews",
			"Simon McAdam",
			"Matthew David McCarthy",
			"Stephen McDade",
			"Allistair McNab",
			"Rory Mulroe",
			"Jonathan Nadav",
			"Cali Nelle",
			"Michael Nicolae",
			"Emeson Nwolie",
			"Richard Ochampaugh",
			"Tatsujiro Oto",
			"Marianna Panunzio",
			"Oliver Price",
			"Milan Pulvermacher",
			"Diezel Ramos",
			"James Michael Rankin",
			"Caroline Guy Roberta",
			"Steve Saunders",
			"Kelly Schembri",
			"Kim Sheard",
			"Stuart Shepherd-Garner",
			"Tina Simmons",
			"Clem So",
			"Richard Stanley",
			"Leon Symnz",
			"David Terry",
			"Phillip Ray Tommy",
			"Lucia Walker",
			"Damien Walters",
			"Naomi Westerman",
			"Daniel Westwood",
			"Ryan Young",
			"Miroslav Zaruba",
			"Tatiana Zarubova",
		],
		directors: ["Matthew Vaughn", "Lucy Ward"],
		countries: ["United Kingdom", "United States of America", "UK, USA"],
		language: ["English", "en", "English, Arabic, Swedish"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "1917",
		description:
			"At the height of the First World War, two young British soldiers must cross enemy territory and deliver a message that will stop a deadly attack on hundreds of soldiers.",
		tagline: "Time is the enemy",
		year: "2019",
		release_date: "2019-12-25",
		imdb_id: "tt8579674",
		imdb_rating: "7.994",
		vote_count: "11945",
		popularity: "56.058",
		youtube_trailer_key: "UcmZN0Mbl04",
		rated: "R",
		runtime: 119,
		genres: ["War", "Action", "Drama", "History", "Thriller"],
		stars: [
			"George MacKay",
			"Dean-Charles Chapman",
			"Mark Strong",
			"Andrew Scott",
			"Richard Madden",
			"Claire Duburcq",
			"Colin Firth",
			"Benedict Cumberbatch",
			"Daniel Mays",
			"Adrian Scarborough",
			"Chris Walley",
			"Nabhaan Rizwan",
			"Jamie Parker",
			"Tommy French",
			"Paul Tinto",
			"Billy Postlethwaite",
			"Richard McCabe",
			"Justin Edwards",
			"Pip Carter",
			"Andy Apollo",
			"Josef Davies",
			"Gabriel Akuwudike",
			"Spike Leighton",
			"Robert Maaser",
			"Gerran Howell",
			"Adam Hugill",
			"Benjamin Adams",
			"Anson Boon",
			"Kenny Fullwood",
			"Ryan Nolan",
			"Elliot Baxter",
			"Kye Mckee",
			"Ivy-I Macnamara",
			"Merlin Leonhardt",
			"Taddeo Kufus",
			"Jos Slovick",
			"Luke Hornsby",
			"Jack Shalloo",
			"Elliot Edusah",
			"Joe Anders",
			"Jacob James Beswick",
			"Michael Jibson",
			"Ian Wilson",
			"Bradley Connor",
			"John Hollingworth",
			"Samson Cox-Vinell",
			"Jonny Lavelle",
			"Michael Rouse",
			"Richard Dempsey",
			"Phil Cheadle",
			"Jonah Russell",
			"Daniel Attwell",
			"Bogdan Kumshatsky",
			"Joe Mendes",
			"Bogdan Kumsackij",
			"Ivy-l Macnamara",
			"Charles Alexandre",
			"Spencer Allum",
			"Kaine Applegate",
			"Anj Avraam",
			"Owun Birkett",
			"Fabio Bocca",
			"Jake Burnside",
			"Harrison Cope",
			"Richard Curtis",
			"Tom Dunham",
			"Kieran Geary",
			"Joseph Aston Grant",
			"Scott Harrington",
			"Sammy John Heaney",
			"Mikel Iriarte",
			"Robin Lee",
			"Teresa Mahoney",
			"Ibrahim Majid",
			"Ketan Majmudar",
			"Charlie McLeod",
			"Joseph Mills",
			"Michael Mortimer",
			"Callum Needham",
			"Mark Oldridge",
			"Richard Price",
			"Jon Ramsbottom",
			"Mark Schneider",
			"Will Sharp",
			"Daniel Smales",
			"Richard Townsley",
			"James Troake",
			"Josh Turner",
			"Patrick Walsh",
			"James Willmott",
			"Fraser Young",
		],
		directors: ["Sam Mendes", "Nicoletta Mani", "Michael Lerman", "Joey Coughlin"],
		countries: ["India", "Spain", "United Kingdom", "United States of America", "Canada"],
		language: ["English", "Fran\u00e7ais", "Deutsch", "en"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "All Quiet on the Western Front",
		description:
			"Paul Baumer and his friends Albert and Muller, egged on by romantic dreams of heroism, voluntarily enlist in the German army. Full of excitement and patriotic fervour, the boys enthusiastically march into a war they believe in. But once on the Western Front, they discover the soul-destroying horror of World War I.",
		tagline: null,
		year: "2022",
		release_date: "2022-10-07",
		imdb_id: "tt1016150",
		imdb_rating: "7.7",
		vote_count: "3607",
		popularity: "60.154",
		youtube_trailer_key: "3qP0Z04UrJY",
		rated: "R",
		runtime: 147,
		genres: ["Drama", "War", "Action", "Documentary", "History"],
		stars: [
			"Felix Kammerer",
			"Albrecht Schuch",
			"Aaron Hilmer",
			"Moritz Klaus",
			"Adrian Gr\u00fcnewald",
			"Edin Hasanovi\u0107",
			"Daniel Br\u00fchl",
			"Thibault de Montalembert",
			"Devid Striesow",
			"Andreas D\u00f6hler",
			"Sebastian H\u00fclk",
			"Luc Feit",
			"Michael Wittenborn",
			"Michael Stange",
			"Sascha Nathan",
			"Tobias Langhoff",
			"Anton von Lucke",
			"Michael Pitthan",
			"Joe Weintraub",
			"Charles Morillon",
			"Gabriel Dufay",
			"Dan Brown",
			"Philipp Schenker",
			"Cyril Dobr\u00fd",
			"Sebastian Jacques",
			"Gregory Gudgeon",
			"Cyril \u010cech\u00e1k",
			"Jakob Schmidt",
			"Felix von Bredow",
			"Martin Dost\u00e1l",
			"Marek Simbersky",
			"Jakob Diehl",
			"Friedrich Berger",
			"Anthony Paliotti",
			"Radek Brodil",
			"Jonathan Henault",
			"Nico Ehrenteit",
			"Hendrik Heutmann",
			"Daniel-Frantisek Kamen",
			"Tom\u00e1\u0161 \u010capek",
			"Markus Tomczyk",
			"Emil Rothermel",
			"Wolf Danny Homann",
			"Michal Z\u00e1vodsk\u00fd",
			"Nicolas Prokop",
			"Jacob Zacharias Eckstein",
			"Adam Mensdorff",
			"Peter Sikorski",
			"Al\u017eb\u011bta Mal\u00e1",
			"Andrea Zatloukalov\u00e1",
			"Thomas Zielinski",
			"Tom\u00e1\u0161 Weber",
			"Samuel Neduha",
			"Martin N\u011bmec",
			"Tom\u00e1\u0161 Merkl",
			"Edin Hasanovic",
			"Andr\u00e9 Marcon",
		],
		directors: ["Edward Berger"],
		countries: ["Germany", "United States of America"],
		language: ["Fran\u00e7ais", "English", "Deutsch", "de"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Watchmen",
		description:
			"In a gritty and alternate 1985 the glory days of costumed vigilantes have been brought to a close by a government crackdown, but after one of the masked veterans is brutally murdered, an investigation into the killer is initiated. The reunited heroes set out to prevent their own destruction, but in doing so uncover a sinister plot that puts all of humanity in grave danger.",
		tagline: "Justice is coming to all of us.  No matter what we do.",
		year: "2009",
		release_date: "2009-03-05",
		imdb_id: "tt0409459",
		imdb_rating: "7.3",
		vote_count: "6313",
		popularity: "32.176",
		youtube_trailer_key: "PVgUZ2NSzBo",
		rated: "R",
		runtime: 163,
		genres: ["Action", "Mystery", "Sci-Fi", "Adventure", "Drama"],
		stars: [
			"Jackie Earle Haley",
			"Patrick Wilson",
			"Jeffrey Dean Morgan",
			"Laura Mennell",
			"Billy Crudup",
			"Matthew Goode",
			"Carla Gugino",
			"Malin \u00c5kerman",
			"Matt Frewer",
			"Stephen McHattie",
			"Rob LaBelle",
			"Gary Houston",
			"James M. Connor",
			"Mary Ann Burger",
			"John Shaw",
			"Robert Wisden",
			"Jerry Wasserman",
			"Don Thompson",
			"Frank Novak",
			"Sean Allan",
			"Garry Chalk",
			"Stephanie Belding",
			"Michael Kopsa",
			"William S. Taylor",
			"Chris Burns",
			"Malcolm Scott",
			"Danny Wattley",
			"Nhi Do",
			"Walter Addison",
			"David Mackay",
			"Keith Martin Gordey",
			"Fulvio Cecere",
			"Ted Cole",
			"Mark Acheson",
			"John Destry",
			"Chris Gauthier",
			"L. Harvey Gold",
			"Jay Brazeau",
			"Jesse Reid",
			"Manoj Sood",
			"Dan Payne",
			"Niall Matter",
			"Apollonia Vanova",
			"Glenn Ennis",
			"Darryl Scheelar",
			"Clint Carleton",
			"Brett Stimely",
			"Carrie Genzel",
			"Greg Travis",
			"Greg Armstrong-Morris",
			"Andrew Colthart",
			"Bruce Crawford",
			"Sal Sortino",
			"Eli Snyder",
			"Lori Watt",
			"Tony Bardach",
			"John Kobylka",
			"Carmen Lavigne",
			"J.R. Killigrew",
			"Steven Stojkovic",
			"Martin Reiss",
			"Frank Cassini",
			"John R. Taylor",
			"Tara Frederick",
			"Daryl Shuttleworth",
			"Jaryd Heydrick",
			"Ron Chartier",
			"Carly Bentall",
			"Matt Drake",
			"Haley Guiel",
			"Sonya Salomaa",
			"Tyler McClendon",
			"Salli Saffioti",
			"Neil Schell",
			"Michael Eklund",
			"Deborah Finkel",
			"Louis Chirillo",
			"Marsha Regis",
			"Patrick Sabongui",
			"John Tench",
			"Santo Lombardo",
			"Jason Schombing",
			"Darren Shahlavi",
			"Marshall Virtue",
			"Colin Lawrence",
			"Chris Weber",
			"Alessandro Juliani",
			"Alison Araya",
			"Sahar Biniaz",
			"Matthew Harrison",
			"Bernadeta Wrobel",
			"Youri Obryvtchenko",
			"Heidi Iro",
			"Kit Noon",
			"Parm Soor",
			"Cristina Menz",
			"Lynn Colliar",
			"Tony Ali",
			"Katie Bennison",
			"Ian Farthing",
			"Calvin Lee",
			"Alexander Mandra",
			"Isabelle Champeau",
			"Ashley O'Connell",
			"Mark Gash",
			"Suzanne E. Smith",
			"Agam Darshi",
			"Tom McBeath",
			"Kevin McNulty",
			"Mark Docherty",
			"Clay St. Thomas",
			"Dale Wolfe",
			"Ken Tremblett",
			"Dawn Chubai",
			"Manuelita Kinsey",
			"Tamara Stanners",
			"Sahara Davis",
			"Dave Hospes",
			"Greig Hospess",
			"Ali Dunn",
			"Jeffrey Frieler",
			"Kurt Evans",
			"Sylvesta Stuart",
			"Terence Kelly",
			"Mi-Jung Lee",
			"Ted Friend",
			"Tiffany Burns",
			"Michael Adamthwaite",
			"Danny Woodburn",
			"Zack Snyder",
			"Clay Enos",
			"Sylvester Stallone",
			"Malin Akerman",
			"Ron Fassler",
			"David MacKay",
			"Mike Carpenter",
			"Leah Gibson",
			"Jaryd Heidrick",
			"Kit Koon",
			"Greig Hospes",
			"Jeffrey Flieler",
			"Luke Burnyeat",
			"Damon Caro",
			"Douglas Chapman",
			"Trevor Coppola",
			"Dave Cote",
			"Sayla de Goede",
			"Gary A. Hecker",
			"Andres Markwart",
			"Ed Metzger",
			"Yoosik Oum",
			"Kennith Overbey",
			"Michael Stevens",
		],
		directors: ["Martin Walters", "Zack Snyder", "Kimi Webber"],
		countries: ["United States of America", "USA"],
		language: ["English", "en"],
		status: "OK",
	},
	{
		title: "Dune: Part Two",
		description:
			"Follow the mythic journey of Paul Atreides as he unites with Chani and the Fremen while on a path of revenge against the conspirators who destroyed his family. Facing a choice between the love of his life and the fate of the known universe, Paul endeavors to prevent a terrible future only he can foresee.",
		tagline: "Long live the fighters.",
		year: "2024",
		release_date: "2024-02-27",
		imdb_id: "tt15239678",
		imdb_rating: "8.169",
		vote_count: "4418",
		popularity: "763.143",
		youtube_trailer_key: "Way9Dexny3w",
		rated: "PG-13",
		runtime: 167,
		genres: [
			"Sci-Fi",
			"Adventure",
			"Romance",
			"Action",
			"Drama",
			"Animation",
			"Biography",
			"Comedy",
			"Crime",
			"Documentary",
			"Family",
			"Fantasy",
			"History",
			"Horror",
			"Musical",
			"Mystery",
			"Sport",
			"Thriller",
			"War",
			"Western",
		],
		stars: [
			"Timoth\u00e9e Chalamet",
			"Zendaya",
			"Rebecca Ferguson",
			"Javier Bardem",
			"Josh Brolin",
			"Austin Butler",
			"Florence Pugh",
			"Dave Bautista",
			"Christopher Walken",
			"L\u00e9a Seydoux",
			"Stellan Skarsg\u00e5rd",
			"Charlotte Rampling",
			"Souheila Yacoub",
			"Roger Yuan",
			"Babs Olusanmokun",
			"Alison Halstead",
			"Giusi Merli",
			"Kait Tenison",
			"Tara Breathnach",
			"Akiko Hitomi",
			"Imola G\u00e1sp\u00e1r",
			"Alison Adnet",
			"Hamza Baissa",
			"Hassan Najib",
			"Jasper Ryan-Carter",
			"Elbooz Omar Ahmed Fathie",
			"Abdelkarim Hussein Seli Mohamed Hassanin",
			"Joseph Beddelem",
			"Xavier Alba Royo",
			"Rachid Abbad",
			"Affif Ben Badra",
			"Botond B\u00f3ta",
			"Abdelaziz Boumane",
			"Abdellah Echahbi",
			"Zouhair Elakkari",
			"Noureddine Hajoujou",
			"Mohamed Mouraoui",
			"Adil Achraf Sayd",
			"Hamza Sayd",
			"Hopi Grace",
			"Havin Fathi",
			"Kincs\u00f6 Peth\u00f6",
			"Cat Simmons",
			"Burt Caesar",
			"Remi Fadare",
			"Amer El-Erwadi",
			"Tedroy Newell",
			"Oxa Hazel",
			"Hajiyeva Pakiza",
			"Leon Herbert",
			"Sima Rostami",
			"Yvonne Campbell",
			"Joseph Charles",
			"Vic Zander",
			"Dylan Baldwin",
			"Marcia Tucker",
			"Nicola Brome",
			"Kathy Owen",
			"Huw Novelli",
			"Moe Bar-El",
			"Serhat Metin",
			"Amra Mallassi",
			"Adam Bloom",
			"Luis Alkmim",
			"Jordan Long",
			"Omar A.K.",
			"Zden\u011bk Dvo\u0159\u00e1\u010dek",
			"Billy Clements",
			"Anton Saunders",
			"Lex Daniel",
			"Dominic McHale",
			"Paul Boyle",
			"Niall White",
			"Tony Cook",
			"G\u00e1bor Szem\u00e1n",
			"Jonathan Gunning",
			"Will Irvine",
			"Alan Mehdizadeh",
			"Rex Adams",
			"Molly Mcowan",
			"Ana Cilas",
			"Kajsa Mohammar",
			"S\u00e1ra B\u00e1csfalvi",
			"Zs\u00f3fia Kocsis",
			"Matthew Sim",
			"Steve Wall",
			"Italo Amerighi",
			"Tim Hilborne",
			"Cecile Sinclair",
			"Tracy Coogan",
			"Zoe Kata Kaska",
			"Jimmy Walker",
			"Rand Faris",
			"Fouad Humaidan",
			"Manaf Irani",
			"Dora K\u00e1polnai-Schvab",
			"Joelle",
			"Anya Taylor-Joy",
			"Peter Sztojanov Jr.",
			"Alexandra T\u00f3th",
			"\u63d0\u83ab\u897f\u00b7\u67e5\u62c9\u6885",
			"Kocsis Zsofia",
			"Murray Keane",
			"Ty Guldeman",
			"Omar Elbooz",
			"Abdelkarim Hussein Seli Mohamed",
			"Sara Bacsfalvi",
			"Laura Mizere",
			"Sebastian Faure",
			"Hassanin",
			"Maddie Phillips",
			"Mira Sorvino",
			"Tara Strong",
			"Matthew Lillard",
			"Jason Statham",
			"Stephen McKinley Henderson",
			"Tim Blake Nelson",
			"Benjamin Cl\u00e9mentine",
			"Barry Keoghan",
		],
		directors: [
			"Denis Villeneuve",
			"Toby Hefferman",
			"Vera Janisch",
			"Tam\u00e1s P\u00e9ter Chipie",
			"Tarik Afifi",
			"George Max Trummler",
			"Louis Clark",
		],
		countries: ["United States of America", "Canada"],
		language: ["English", "en", "Espa\u00f1ol"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Cloverfield",
		description:
			"Five young New Yorkers throw their friend a going-away party the night that a monster the size of a skyscraper descends upon the city. Told from the point of view of their video camera, the film is a document of their attempt to survive the most surreal, horrifying event of their lives.",
		tagline: "Some thing has found us.",
		year: "2008",
		release_date: "2008-01-15",
		imdb_id: "tt1060277",
		imdb_rating: "6.682",
		vote_count: "6770",
		popularity: "40.483",
		youtube_trailer_key: "wxqSIsxMlYQ",
		rated: "PG-13",
		runtime: 85,
		genres: ["Action", "Thriller", "Sci-Fi", "Adventure", "Horror", "Mystery"],
		stars: [
			"Lizzy Caplan",
			"Jessica Lucas",
			"T.J. Miller",
			"Michael Stahl-David",
			"Mike Vogel",
			"Odette Annable",
			"Anjul Nigam",
			"Margot Farley",
			"Theo Rossi",
			"Brian Klugman",
			"Kelvin Yu",
			"Liza Lapira",
			"Lili Mirojnick",
			"Ben Feldman",
			"Elena Caruso",
			"Vakisha Coleman",
			"Will Greenberg",
			"Rob Kerkovich",
			"Ryan Key",
			"Hooman Khalili",
			"Rasika Mathur",
			"Baron Vaughn",
			"Charlyne Yi",
			"Roma Torre",
			"Rick Overton",
			"Martin Cohen",
			"Jason Cerbone",
			"Pasha D. Lychnikoff",
			"Billy Brown",
			"Scott Lawrence",
			"Jeffrey De Serrano",
			"Tim Griffin",
			"Chris Mulkey",
			"Susse Budde",
			"Jason Lombard",
			"Jamie Martz",
			"Matt Reeves",
			"Michael Ark",
			"Caley Bisson",
			"Maylen Calienes",
			"Craig Dabbs",
			"Jason Giffin",
			"Hisonni Johnson",
			"Adam Karst",
			"Julio Leal",
			"Gene Richards",
			"Bertrand Roberson Jr.",
			"Chris Spinelli",
			"Rick Shuster",
			"Jake McLaughlin",
			"T. J. Miller",
			"Don Abernathy",
			"James Thomas Bligh",
			"Tommy Gerrits",
			"Adam Greeves",
			"Brandon G. Holley",
			"Rachel Mower",
			"John Robert",
			"Andrew Trujillo",
			"Maria Zambrana",
			"Pavel Lychnikoff",
			"Doby Daenger",
			"Holly Dunlap",
			"Paulo Giusti",
			"Brice Harris",
			"James Huffman",
			"Janis Jones",
			"Eddie Mariano",
			"Aryn Nelson",
		],
		directors: ["Matt Reeves", "Dawn Gilliam", "Rip Murray", "Louis Guerra", "Katie Carroll", "Efrain Cortes"],
		countries: ["United States of America", "USA"],
		language: ["P\u0443\u0441\u0441\u043a\u0438\u0439", "English", "en", "English, Russian"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Into the Wild",
		description:
			"After graduating from Emory University in 1992, top student and athlete Christopher McCandless abandons his possessions, gives his entire $24,000 savings account to charity, and hitchhikes to Alaska to live in the wilderness.",
		tagline: "Into the heart. Into the soul.",
		year: "2007",
		release_date: "2007-09-21",
		imdb_id: "tt0758758",
		imdb_rating: "7.806",
		vote_count: "9312",
		popularity: "36.042",
		youtube_trailer_key: "g7ArZ7VD-QQ",
		rated: "R",
		runtime: 148,
		genres: ["Adventure", "Drama", "Action", "Biography", "Romance"],
		stars: [
			"Emile Hirsch",
			"Marcia Gay Harden",
			"William Hurt",
			"Jena Malone",
			"Brian H. Dierker",
			"Catherine Keener",
			"Vince Vaughn",
			"Kristen Stewart",
			"Hal Holbrook",
			"Thure Lindhardt",
			"Signe Egholm Olsen",
			"Jim Gallien",
			"James J. O'Neill",
			"Malinda McCollum",
			"Paul Knauls",
			"Zach Galifianakis",
			"Craig Mutsch",
			"Jim Beidler",
			"John Decker",
			"John Hofer",
			"Jerry Hofer",
			"Terry Waldner",
			"Robin Mathews",
			"Candice Campos",
			"Steven Wiig",
			"Floyd Wall",
			"Bryce Walters",
			"Jim Davis",
			"Cheryl Francis Harrington",
			"R. D. Call",
			"Haley Ramm",
			"Merritt Wever",
			"Everett 'Insane Wayne' Smith",
			"John Jabaley",
			"Leonard Knight",
			"Matt Contreras",
			"Denise Sitton",
			"Sharon Olds",
			"Carine McCandless",
			"J. Nathan Simmons",
			"Parris Mosteller",
			"Timothy Levine",
			"Haley Sweet",
			"Aaron Wayne Hill",
			"Bart the Bear II",
			"R.D. Call",
			'Everett "Insane Wayne" Smith',
			"James O'Neill",
			"Bart the Bear",
			"Dan Burch",
			"Joe Dustin",
			"Golbon Eghtedari",
			"Alvin Ellie",
			"Caroline Gelabert",
			"Geri Gilmore",
			"Paul Haasch",
			"Mad Martian",
			"Jenna Romero",
			"Rocky Self",
			"Susan Spencer",
			"Edward Tubbs",
		],
		directors: ["Sean Penn", "David Webb", "Luca Kouimelis", "Lyn Matsuda Norton", "John R. Saunders"],
		countries: ["United States of America", "USA"],
		language: ["Dansk", "English", "en", "English, Danish"],
		status: "OK",
		status_message: "Query was successful",
	},
];

const getMovieImageUrl = (id) => {
	return `/data/moviePosters/${id}.jpg`;
};

function filter(movies) {
	return movies.map((element) => {
		return {
			id: element.imdb_id,
			rating: element.imdb_rating ? parseFloat(element.imdb_rating).toFixed(1) : "N/A",
			title: element.title || "N/A",
			description: element.description || "No description available",
			img: getMovieImageUrl(element.imdb_id),
			releaseYear: element.year_started || element.year || "N/A",
			actors: element.stars ? element.stars.slice(0, 3) : "N/A",
			genres: element.genres ? element.genres.map((genre) => genre) : [],
			trailer: "https://www.youtube.com/watch?v=" + element.youtube_trailer_key,
		};
	});
}

export default filter(recomendedMovies);
